export const CANVAS_ID = 'CANVAS'

export const MIN_DESCRIPTION_LENGTH = 70
export const DESCRIPTION_PLACEHOLDER = 'A Serverless application that...'
export const DEFAULT_FLOW_STEPS = '10'
export const MIN_FLOW_STEPS = 1
export const MAX_FLOW_STEPS = 12